import { render, staticRenderFns } from "./ArtworkSidebarPreviewImage.vue?vue&type=template&id=387b9cd3&scoped=true&"
import script from "./ArtworkSidebarPreviewImage.vue?vue&type=script&lang=js&"
export * from "./ArtworkSidebarPreviewImage.vue?vue&type=script&lang=js&"
import style0 from "./ArtworkSidebarPreviewImage.vue?vue&type=style&index=0&id=387b9cd3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387b9cd3",
  null
  
)

export default component.exports